import React from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import styles from './ProjectsHero.module.scss';
import { PrimaryButton } from '../../../components';
import useCalendly from '../../Calendly';
import Image from 'next/image';
import { getSiteUiFromPath } from '../../../lib/polylang';

export default function ProjectsHero({ data }) {
  const router = useRouter();
  const ui = getSiteUiFromPath(router.asPath);

  if (!data) return null;

  const { mainHeaderText, smallTopHeader, subText, button, logo } = data;
  const { openCalendlyInline } = useCalendly();
  
  // Check if button should use Calendly (if no URL is provided or if it's a booking-related button)
  const shouldUseCalendly = !button?.buttonLink?.url || 
                           (button?.buttonText && button.buttonText.toLowerCase().includes('møte'));

  return (
    <section className={styles.heroSection}>
      <div className={styles.container}>
        <div className={styles.content}>
          {smallTopHeader && (
            <span className={styles.smallHeader}>{ui.breadcrumbProjects}</span>
          )}
          {mainHeaderText && <h1>{mainHeaderText}</h1>}
          <div className={styles.textButtonWrapper}>
            {subText && <p className={styles.subText}>{subText}</p>}
            <div className={styles.buttonWrapper}>
              {shouldUseCalendly ? (
                <PrimaryButton
                  text={ui.bookFreeIntroMeeting}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    openCalendlyInline(e, 'https://calendly.com/sales-mediabooster/intromote-digital-markedsforing');
                  }}
                />
              ) : (
                <PrimaryButton
                  href={button.buttonLink.url}
                  text={ui.bookFreeIntroMeeting}
                  external={button.buttonLink.target === '_blank'}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
} 